import { createRouter, createWebHistory } from "vue-router";
import { applySeoMeta } from "@/composables/useSeoMeta";
import { upsertJsonLd } from "@/composables/useJsonLd";
import { buildBreadcrumbList } from "@/seo/structuredData";
import { routesMeta, isCatalogIndexable, breadcrumbLabels } from "@/seo/routesMeta";

const routes = [
  {
    path: "/",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "main" */ "@/views/HomeV2View.vue"),
  },
  {
    path: "/inicio-anterior",
    name: "HomeLegacy",
    component: () =>
      import(/* webpackChunkName: "main" */ "@/views/HomeView.vue"),
  },
  {
    path: "/inicio-nuevo",
    name: "HomeV2Preview",
    component: () =>
      import(/* webpackChunkName: "main" */ "@/views/HomeV2View.vue"),
  },
  {
    path: "/about",
    name: "About",
    component: () =>
      import(/* webpackChunkName: "main" */ "@/views/AboutView.vue"),
  },
  {
    path: "/catalogo/:op/:id/:id2",
    name: "catalogo",
    component: () =>
      import(/* webpackChunkName: "main" */ "@/views/CatalogoView.vue"),
  },
  {
    path: "/detalles/:id",
    name: "detalles",
    component: () =>
      import(/* webpackChunkName: "main" */ "@/views/CarDataSheet.vue"),
  },
  {
    path: "/contacto",
    name: "contacto",
    component: () =>
      import(/* webpackChunkName: "main" */ "@/views/Contacto.vue"),
  },
  {
    path: "/recomendaciones",
    name: "recomendaciones",
    component: () =>
      import(/* webpackChunkName: "main" */ "@/views/Recomendaciones.vue"),
  },
  {
    path: "/blog",
    name: "blog",
    component: () =>
      import(/* webpackChunkName: "main" */ "@/views/BlogView.vue"),
  },
  {
    path: "/tracking/:id",
    name: "tracking",
    component: () =>
      import(/* webpackChunkName: "main" */ "@/views/TrackingView.vue"),
  },
  {
    path: "/favoritos",
    name: "favoritos",
    component: () =>
      import(/* webpackChunkName: "main" */ "@/views/FavoritosView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Aplica la metadata SEO base (title, description, robots, canonical, OG,
// Twitter) tan pronto como se confirma la navegación, antes de que el
// componente de la nueva ruta termine de montarse. Las vistas con datos
// dinámicos (CarDataSheet, CatalogoView) refinan esta metadata una vez que
// cargan su información llamando de nuevo a useSeoMeta/useJsonLd.
router.afterEach((to) => {
  const meta = routesMeta[to.name] || {};
  let robots = meta.robots;
  let canonical = meta.canonicalPath;

  if (to.name === "catalogo") {
    const indexable = isCatalogIndexable(to.params);
    robots = indexable ? "index, follow" : "noindex, follow";
    canonical = "/catalogo/0/0/0";
  }

  applySeoMeta({
    title: meta.title,
    description: meta.description,
    path: to.path,
    canonical,
    robots,
  });

  // BreadcrumbList genérico (Inicio > Sección). La home no lo necesita y
  // "detalles" arma el suyo propio (ld-breadcrumb-detalle) con el nombre
  // real del vehículo, así que aquí solo limpiamos este genérico para no
  // dejar un breadcrumb obsoleto de la ruta anterior.
  if (to.name === "Home" || to.name === "detalles") {
    upsertJsonLd("ld-breadcrumb", null);
    return;
  }
  const label = breadcrumbLabels[to.name];
  upsertJsonLd(
    "ld-breadcrumb",
    label ? buildBreadcrumbList([{ name: "Inicio", path: "/" }, { name: label }]) : null
  );
});

export default router;
